import { render, staticRenderFns } from "./profileSetting.vue?vue&type=template&id=e672f95e&scoped=true"
import script from "./profileSetting.vue?vue&type=script&lang=js"
export * from "./profileSetting.vue?vue&type=script&lang=js"
import style0 from "./profileSetting.vue?vue&type=style&index=0&id=e672f95e&prod&scoped=true&lang=scss"
import style1 from "./profileSetting.vue?vue&type=style&index=1&id=e672f95e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e672f95e",
  null
  
)

export default component.exports